import { render, staticRenderFns } from "./AuthSignupPracticeForm.vue?vue&type=template&id=6fb1f08e&scoped=true"
import script from "./AuthSignupPracticeForm.vue?vue&type=script&lang=js"
export * from "./AuthSignupPracticeForm.vue?vue&type=script&lang=js"
import style0 from "./AuthSignupPracticeForm.vue?vue&type=style&index=0&id=6fb1f08e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb1f08e",
  null
  
)

export default component.exports